export const InputTypes = {
  CHECKBOX: 'checkbox',
  SLIDER: 'slider',
  LOCAL_SEARCH: 'local_search',
};

export const silderTypes = {
  INPUT_MIN: 'INPUT_MIN',
  INPUT_MAX: 'INPUT_MAX',
};
